import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/notification/notification.scss";
import { Button, Form } from "react-bootstrap";
import ShowEntries from "../commoncomponents/ShowEntries";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import queryString from "query-string";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import NotificationTable from "./notificationTable";

class Notifications extends Component {

  constructor(props) {
    super(props);
    this.state = {
      NotificationList: [],
      searchKey: "",
      pageCount: 0,

      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "1",
      entryEnd: "50",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,
      statusFilter: "all",
    };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    console.log("customerID", values.customerId);
    var urlAll = "";
    if (values.customerId) {
      this.customerId = values.customerId;
      let query = encodeQueryData(this.setNotificationQueryObject());
      urlAll = `${apiHost}/api/Notification/AllNotification?${query}`;
      this.getNotification(urlAll);
    } else {
      let query = encodeQueryData(this.setNotificationQueryObject());

      urlAll = `${apiHost}/api/Notification/AllNotification?${query}`;
      this.getNotification(urlAll);
    }
  }

  handleShowEntries = (inputShowEntries) => {
    console.log(inputShowEntries);
    this.pageSize = inputShowEntries;
    let query = encodeQueryData(this.setNotificationQueryObject());
    let urlAll = `${apiHost}/api/Notification/AllNotification?${query}`;
    this.getNotification(urlAll);
  };

  setNotificationQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageSize == 1000000 ? 1 : this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;

    return data;
  };
  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setNotificationQueryObject());
    let urlAll = `${apiHost}/api/Notification/AllNotification?${query}`;
    this.getNotification(urlAll);
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setNotificationQueryObject());
    let urlAll = `${apiHost}/api/Notification/AllNotification?${query}`;
    this.getNotification(urlAll);
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessage: false });
    } else {
      this.setState({ filterMessage: true });
    }

    this.searchText = inputSearch;
    let query = encodeQueryData(this.setNotificationQueryObject());
    let urlAll = `${apiHost}/api/Notification/AllNotification?${query}`;
    this.getNotification(urlAll);
  };

  getNotification = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      let NotificationList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("NotificationList", NotificationList);
      // NotificationList.data.sort((a,b) => {
      //   if(a.customerName.toLowerCase() < b.customerName.toLowerCase()){
      //     return -1;
      //   }
      //   else if(a.customerName.toLowerCase() > b.customerName.toLowerCase()){
      //     return 1;
      //   }
      //   else if(a.name.toLowerCase() < b.name.toLowerCase()){
      //     return -1;
      //   } else if(a.name.toLowerCase() > b.name.toLowerCase()){
      //     return 1;
      //   } else{
      //     return 0;
      //   }
      // })
      this.setState({
        NotificationList: NotificationList.data,
        pageCount: JSON.parse(NotificationList.headers.pagination).totalPages,
      });
      this.handleShowResults(NotificationList);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleShowResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(response.headers.pagination).totalItems,
        totalFilter: true,
      });
    }
    this.setState({
      entryStart: parseInt(this.pageSize) == 1000000 ? 1 : (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEnd)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.pageSize);
      this.setState({ entryEnd: value });
    }
    if (
      this.state.entryEnd >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.NotificationList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/create-new-notification?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push(`/create-new-notification`);
    }
  };

  getStatusCounts = () => {
    return this.state.NotificationList.reduce(
      (counts, notification) => {
        const status = this.normalizeNotificationStatus(notification.status);

        counts.all += 1;

        if (status === "active") {
          counts.active += 1;
        }

        if (status === "disabled") {
          counts.disabled += 1;
        }

        return counts;
      },
      { all: 0, active: 0, disabled: 0 }
    );
  };

  normalizeNotificationStatus = (status) => {
    const normalizedStatus = (status || "").toString().toLowerCase();

    if (normalizedStatus === "active" || normalizedStatus === "1") {
      return "active";
    }

    if (
      normalizedStatus === "disabled" ||
      normalizedStatus === "disable" ||
      normalizedStatus === "0"
    ) {
      return "disabled";
    }

    return "unknown";
  };

  handleStatusFilter = (statusFilter) => {
    this.setState({ statusFilter });
  };

  getFilteredNotifications = () => {
    if (this.state.statusFilter === "all") {
      return this.state.NotificationList;
    }

    return this.state.NotificationList.filter(
      (notification) =>
        this.normalizeNotificationStatus(notification.status) ===
        this.state.statusFilter
    );
  };

  render() {
    const arr = [50, 100, 150, 200, 1000000];
    const { pageCount } = this.state;
    const values = queryString.parse(this.props.location.search);
    const role = localStorage.getItem("role");
    const isSystemAdmin = role == "SystemAdmin";
    const isPersonalMode = !isSystemAdmin;
    const statusCounts = this.getStatusCounts();
    const filteredNotifications = this.getFilteredNotifications();
    const isStatusFiltered = this.state.statusFilter !== "all";
    const statusFilters = [
      { key: "all", label: "All", count: statusCounts.all },
      { key: "active", label: "Active", count: statusCounts.active },
      { key: "disabled", label: "Disabled", count: statusCounts.disabled },
    ];
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All Notifications </title>
          </Helmet>

          <div className="contentBody notification-page-shell">
            <div className="contentWrapper notification-page">
              <div className="notification-page-header">
                <div>
                  <h2>{isPersonalMode ? "My Notification Subscriptions" : "Notifications"}</h2>
                  <p>
                    {isPersonalMode
                      ? "Manage your notification requests, schedules and delivery status."
                      : "Manage notification rules, recipients, schedules and delivery status."}
                  </p>
                  {isSystemAdmin && values.customerId && (
                    <a
                      className="notification-filter-chip"
                      onClick={() => localStorage.removeItem("customer")}
                      href="/notifications"
                    >
                      <i className="fa fa-times"></i>
                      {values.customerName}
                    </a>
                  )}
                </div>

                <Button className="notification-primary-button" variant="primary" onClick={() => this.handleCreateNew()}>
                  <i className="fa fa-plus"></i>
                  Create new
                </Button>
              </div>

              <div className="notification-toolbar">
                <div className="notification-search">
                  <i className="fa fa-search"></i>
                  <Form.Control
                    type="text"
                    placeholder={
                      isPersonalMode
                        ? "Search your notifications, unique ID or status"
                        : "Search notifications, customers, users, unique ID or status"
                    }
                    onChange={(event) => this.handleSearch(event.target.value)}
                  />
                </div>

                <div className="notification-status-summary">
                  <span>Page</span>
                  {statusFilters.map((filter) => (
                    <button
                      className={
                        this.state.statusFilter === filter.key ? "active" : ""
                      }
                      key={filter.key}
                      onClick={() => this.handleStatusFilter(filter.key)}
                      type="button"
                    >
                      {filter.label} <em>{filter.count}</em>
                    </button>
                  ))}
                </div>
              </div>

              <div className="notification-table-panel">
                {/* <UserTable UserList={this.state.UserList} /> */}
                <NotificationTable
                  sortFunction={this.handleSort}
                  NotificationList={filteredNotifications}
                  isPersonalMode={isPersonalMode}
                />
              </div>
              <div className="notification-pagination">
                <ShowingResults
                  currentEntryStart={
                    isStatusFiltered && filteredNotifications.length === 0
                      ? 0
                      : isStatusFiltered
                      ? 1
                      : this.state.entryStart
                  }
                  currentEntryEnd={
                    isStatusFiltered
                      ? filteredNotifications.length
                      : this.state.entryEnd
                  }
                  totalEntries={
                    isStatusFiltered
                      ? filteredNotifications.length
                      : this.state.totalEntry
                  }
                  totalFilterEntries={
                    isStatusFiltered
                      ? statusCounts.all
                      : this.state.totalEntryFilter
                  }
                  filterMessage={this.state.filterMessage || isStatusFiltered}
                />
                <Paginations
                  onPagination={this.handlePagination}
                  pageCount={pageCount}
                  pageRange={5}
                ></Paginations>
                <div className="notification-rows-control">
                  <ShowEntries
                    showEntriesCallback={this.handleShowEntries}
                    data={arr}
                  />
                </div>
              </div>
              {/* <hr />
            <div className="userFooter">
            <p>&copy; 2020 - Vision Trak Rentals Pty Ltd</p>
          </div> */}
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
